export class GetReCaptchaResponseModel {
    CaptchaKey: string;
    CaptchaImage :string;
  }
  